export enum AvailabilityState {
  Add,
  PreOrder,
  BackOrder,
  WhereToBuy,
  ComingSoon,
}
